import { Link } from "react-router-dom";
import { resolveCover } from "@/lib/api";

const sizeClasses = {
  hero: "md:col-span-8 aspect-[4/3] md:aspect-[16/10]",
  tall: "md:col-span-4 md:row-span-2 aspect-[3/4] md:aspect-auto",
  wide: "md:col-span-6 aspect-[4/3]",
  small: "md:col-span-4 aspect-[3/4]",
  square: "md:col-span-4 aspect-square",
};

export const BookCard = ({ book, size = "small", index = 0 }) => {
  return (
    <Link
      to={`/book/${book.id}`}
      data-testid={`book-card-${book.id}`}
      className={`group relative overflow-hidden bg-[var(--bw-surface)] border border-[var(--bw-border)] bw-fade-up ${sizeClasses[size]}`}
      style={{ animationDelay: `${index * 60}ms` }}
    >
      <div className="absolute inset-0 overflow-hidden">
        <img
          src={resolveCover(book.cover_url)}
          alt={book.title}
          className="w-full h-full object-cover transition-transform duration-700 ease-out group-hover:scale-105"
          onError={(e) => {
            e.currentTarget.src =
              "https://images.unsplash.com/photo-1544716278-ca5e3f4abd8c?crop=entropy&cs=srgb&fm=jpg&w=800&q=85";
          }}
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/10 to-transparent" />
      </div>

      <div className="relative h-full flex flex-col justify-between p-5 md:p-6 text-[var(--bw-bg)]">
        <div className="flex items-center justify-between">
          <span className="font-mono-plex text-[10px] uppercase tracking-[0.2em] px-2 py-1 border border-white/40 rounded-full backdrop-blur-sm">
            {book.category || "General"}
          </span>
          <span
            data-testid={`book-price-${book.id}`}
            className="font-mono-plex text-sm bg-[var(--bw-accent)] text-white px-2.5 py-1 rounded-full"
          >
            ${book.price?.toFixed(2)}
            {book.original_price && book.original_price > book.price && (
              <span className="ml-1.5 line-through opacity-70 text-[10px]">
                ${book.original_price.toFixed(2)}
              </span>
            )}
          </span>
        </div>
        <div>
          <h3
            className={`font-serif-display leading-[0.95] tracking-tight ${
              size === "hero"
                ? "text-4xl md:text-6xl"
                : size === "tall"
                ? "text-3xl md:text-4xl"
                : "text-2xl md:text-3xl"
            }`}
          >
            {book.title}
          </h3>
          {book.author && (
            <p className="mt-2 text-sm md:text-base text-white/85">
              by {book.author}
            </p>
          )}
        </div>
      </div>
    </Link>
  );
};

export default BookCard;
